import {
    Cog8ToothIcon,
    ChevronLeftIcon
} from '@heroicons/react/24/outline'
import {goBack} from '../service/router'
import { useNavigate } from "react-router-dom";

function Header(props) {
    const navigate = useNavigate();
    console.log('props',props)
    return (
        <div className="flex bg-violet-50 w-full h-16 items-center justify-between">
            <div>
            {
                props.back &&
                <div className="p-2" onClick={()=>{goBack(navigate)}}>
                    <ChevronLeftIcon className="h-6 w-6 ml-2 mt-[2px] text-header-black text-lg cursor-pointer" />
                </div>
            }
            </div>
            <div className="text-lg font-medium uppercase">{props.title}</div>
            <div className="h-6 w-6 mr-2">
            {
                props.settings &&
                <Cog8ToothIcon className="h-6 w-6 mr-2 mt-[2px] text-header-black text-lg cursor-pointer"/>
            }
            </div>
        </div>
    );
  }
  
  export default Header;
  